import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/affiliate/components/AffiliateCertified/AffiliateCertified.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/affiliate/components/AffiliateFAQ/AffiliateFAQ.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/affiliate/components/AffiliateHero/AffiliateHero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/affiliate/components/AffiliateProcess/AffiliateProcess.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/affiliate/components/AffiliateSupport/AffiliateSupport.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/logo/Logo-trust.tsx");
